export const SKELETON_LOADER_SIZES = {
  small: 'small',
  middle: 'middle',
  big: 'big',
};

export type SkeletonLoaderSizesConstant = 'small' | 'middle' | 'big';
